/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
import {actNetRequestPending, 
        actNetRequestFailed, 
        actNetRequestSuccess,
        netRequestThunk2} from '../../util/netReqRD';

import { sendRequest, sendRequestZabbix } from '../../util/net';
import { hoMessage, hoMessageDestroy } from '../../util/hoComponent';
import { initMenu } from '../../laylout/menu';
import { encrypt } from '../../util/logic';

export const ACT_NET_LOGIN = 'loginRequest';
export const ACT_NET_LOGIN_ZABBIX = 'loginRequestZabbix';
export const ACT_NET_LOGIN_TOKEN_REFRESH = 'loginTokenRefresh';

const ACT_LOGIN_SUCCESS = "ACT_LOGIN_SUCCESS"
const ACT_CLEAN_LOGIN = "ACT_CLEAN_LOGIN"
const ACT_LOGIN_ZABBIX_SUCCESS = "ACT_LOGIN_ZABBIX_SUCCESS"
const ACT_CLEAN_ZABBIX_LOGIN = "ACT_CLEAN_ZABBIX_LOGIN"

// functions
const saveLoginInfo = (reqUserInfo, defaultUser) => {
    const loginInfo = {
        reqUserInfo: reqUserInfo, 
        defaultUser: defaultUser
    };

    try {
        const binState = JSON.stringify(loginInfo);
        localStorage.setItem('cs_mntn_login_info', binState);

    }catch (err){
        console.log('save store loginInfo failed! err: ' + err);
    }
}

const saveToken = (token, refreshToken) => {
    try {
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
    }catch (err){
        console.log('save store loginInfo failed! err: ' + err);
    }
}

const getSavedLoginInfo = () => {
    try {
        const binState = localStorage.getItem('cs_mntn_login_info');
        if (binState === null){
            return undefined;
        }
        return JSON.parse(binState);

    }catch (err){
        return undefined;
    }
}



// reducer handle
const loginState = {
    defaultUser: undefined, 
    reqUserInfo: undefined,
    zabbix: undefined,
};

export const login_reducer = (state=loginState, action) => {
    switch(action.type){
        case ACT_LOGIN_SUCCESS:
            return {
                ...state, 
                defaultUser: action.defaultUser, 
                reqUserInfo: action.reqUserInfo
            };

        case ACT_CLEAN_LOGIN:
            return {
                defaultUser: undefined, 
                reqUserInfo: undefined,
            };

        case ACT_LOGIN_ZABBIX_SUCCESS:
            return {
                ...state, 
                zabbix: action.zabbix, 
            };

        case ACT_CLEAN_ZABBIX_LOGIN:
            return {
                zabbix: undefined, 
            };

        default:
        return state;
    }
}

// select handle
export const getLoginDefaultUserName = (state) => {
    return state.login && state.login.defaultUser;
}

export const getLoginUserInfo = (state) => {
    return state.login && state.login.reqUserInfo;
}

export const getLoginZabbixInfo = (state) => {
    return state.login && state.login.zabbix;
}


// actions handle
// ACT_LOGIN_SUCCESS
export const actLoginSuccess = (reqUserInfo, defaultUser) => {
    
    return {
        type: ACT_LOGIN_SUCCESS, 
        reqUserInfo: reqUserInfo, 
        defaultUser: defaultUser
    }
}

// ACT_LOGIN_SUCCESS
export const actLoginZabbixSuccess = (authID) => {
    
    return {
        type: ACT_LOGIN_ZABBIX_SUCCESS, 
        zabbix: {
            authID: authID,
        }, 
    }
}

export const actLoginClear = () => {
    return {
        type: ACT_CLEAN_LOGIN,
    }
}

// thunk handle
export const loginRequestThunk = (req, successHd = undefined) => async (dispatch, getState) => {
    dispatch(actNetRequestPending(ACT_NET_LOGIN));

    const rsp1 = await sendRequest('/ccs/v1/operator/account/get/token', {
        Account: encrypt(req.username),
        Password: encrypt(req.password),
    });
    if (rsp1 !== undefined){
        if (rsp1.Status !== 0){
            dispatch(actNetRequestFailed(ACT_NET_LOGIN));
            switch(rsp1.Status){
                case 1000: // 密码错误
                default:
                    hoMessage({type: 'error', msg: '登录失败，用户名或密码错误！'});
                    // hoMessage({type: 'error', msg: '服务端错误！'});
                    return;
            }
        }
    }else{
        dispatch(actNetRequestFailed(ACT_NET_LOGIN));
        return;
    }

    const rsp2 = await sendRequest('/ccs/v1/operator/account/info', {}, {Token: rsp1.Token});
    if (rsp2 !== undefined){
        if (rsp2.Status !== 0){
            dispatch(actNetRequestFailed(ACT_NET_LOGIN));
            switch(rsp2.Status){
                default:
                    hoMessage({type: 'error', msg: '登录失败，用户名或密码错误！'});
                    // hoMessage({type: 'error', msg: '服务端错误！'});
                    return;
            }
        } else {
            let roleType = "none"
            switch (rsp2?.AccountInfo?.AccountType) {
                case 49:
                    roleType = "daping.task"
                    break;
                
                case 50:
                    roleType = "daping.data"
                    break;
                
                case 51:
                    roleType = "controller"
                    break;
                
                case 3:
                    roleType = "superadmin"
                    break;
                
                default:
                    roleType = "test"
                    break;
            }

            initMenu(roleType);

            const login = {
                user: {
                    id: rsp2?.AccountInfo?.Id,
                    role: {
                        type: roleType,
                    },
                    name: rsp2?.AccountInfo?.NickName,
                    avatar: rsp2?.AccountInfo?.AvatarUrl,
                },
                auth: {
                    token: rsp1?.Token,
                    expire: rsp1?.Expire,
                    refreshToken: rsp1?.RefreshToken,
                },
                mqttInfo: rsp2?.MqttInfo,
                appInfo: Object.assign(rsp2?.AppInfo, {Account: rsp2?.AccountInfo?.Account})
            }
            // console.log("login, ", login)
            dispatch(actLoginSuccess(login, req.username));
            saveLoginInfo(login, req.username);
            saveToken(login.auth.token, login.auth.refreshToken);
            dispatch(actNetRequestSuccess(ACT_NET_LOGIN));

            if (successHd) {
                successHd(login);
            }
        }
    }else{
        dispatch(actNetRequestFailed(ACT_NET_LOGIN));
    }
}

export function loginNoauthHd(dispatch, orgPath, orgBody, orgHeader, reqUserInfo, routeCode, successFun, errorFun) {
    hoMessageDestroy();
    // window.goToMenu();

    // 重新刷新token
    if (reqUserInfo?.auth?.refreshToken) {
        const path = `/ccs/v1/operator/account/refresh/token`;
        let body = {
            RefreshToken: reqUserInfo?.auth?.refreshToken,
        }
        dispatch(netRequestThunk2(path, body, {}, ACT_NET_LOGIN_TOKEN_REFRESH,
            (dispatch, rsp, req) => {
                // 刷新成功
                reqUserInfo.auth = {
                    token: rsp.Token,
                    expire: rsp.Expire,
                    refreshToken: rsp.RefreshToken,
                }
                dispatch(actLoginSuccess(reqUserInfo));

                // 再次发出之前的请求
                let header = Object.assign(orgHeader, {
                    Token: reqUserInfo?.auth?.token,
                })
                dispatch(netRequestThunk2(orgPath, orgBody, header, routeCode, successFun, errorFun));
            },
            (dispatch, rsp) => {
                switch(rsp.Status){
                    case 100008:
                    default:
                        hoMessage({type: 'error', msg: `Token已失效，请重新登录`, duration: 5});
                        break;
                }
                return true;
            }
        ));

        return true;
    }
    
    return false;

}


// thunk handle
export const loginRequestZabbix = (req, successHd = undefined) => async (dispatch, getState) => {
    dispatch(actNetRequestPending(ACT_NET_LOGIN_ZABBIX));

    const rsp = await sendRequestZabbix({
        "jsonrpc": "2.0",
        "method": "user.login",
        "params": {
            "user": (req && req.username) || "cm",
            "password": (req && req.password) || "online",
        },
        "id": 0,
    }, undefined);
    // console.log(rsp)
    if (rsp !== undefined){
        if (rsp.id !== 0 || rsp.jsonrpc !== "2.0"){
            dispatch(actNetRequestFailed(ACT_NET_LOGIN_ZABBIX));
        }else{
            // console.log("login, ", login)
            dispatch(actLoginZabbixSuccess(rsp.result));
            dispatch(actNetRequestSuccess(ACT_NET_LOGIN_ZABBIX));
            
            if (successHd) {
                successHd(rsp);
            }
        }
    }else{
        dispatch(actNetRequestFailed(ACT_NET_LOGIN_ZABBIX));
    }
}

